<script setup lang="ts">
defineProps<{
  element?: string | Component
}>()
</script>

<template>
  <component
    :is="element || 'div'"
    class="shadow-inner relative overflow-hidden"
  >
    <slot />
  </component>
</template>
